module.exports = __webpack_public_path__ + "static/media/token-dai.2bf6f444.svg";